/* eslint-disable arrow-body-style */
import { toastr } from 'react-redux-toastr';
import APP_ACTIONS from '../constants/app-actions';
import translations from '../../translations/app-translations.json';
import OrdersAPI from '../apis/order';
import order from '../actions/order';

// eslint-disable-next-line arrow-parens
const listenLoginActionMiddleware = store => next => action => {
    if (action && action.type && action.type === APP_ACTIONS.LOGIN) {
        // eslint-disable-next-line camelcase
        const { zones: { currentZone }, locale: { currentLocale }, order: { token } } = store.getState();
        OrdersAPI.getByUser({
            token: action.payload.access_token,
            currentZone,
            locale: currentLocale,
            orderToken: token,
        }).then((response) => {
            store.dispatch(order.updateOrderInState(response.body));
        });
    }
    return next(action);
};

export default listenLoginActionMiddleware;



/** WEBPACK FOOTER **
 ** ./src/middlewares/listen-login-action-middleware.js
 **/